import { render } from "./ChatListBlock.vue?vue&type=template&id=a5d0a69a"
import script from "./ChatListBlock.vue?vue&type=script&lang=js"
export * from "./ChatListBlock.vue?vue&type=script&lang=js"

import "./ChatListBlock.vue?vue&type=style&index=0&id=a5d0a69a&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__